var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createPortal } from 'react-dom';
import { useParams } from 'react-router-dom';
import { MemberStatus } from '@lucidlink/dto/validation';
import { Box, IconButton, LayoutLeftIcon, LoadingBox, Tooltip, translate, useTooltip, } from '@lucidlink/uicore';
import { HEADER_PORTAL_ID } from '#constants';
import { useAppUi } from '#context';
import { useUserWorkspaces } from '#query-hooks';
import { AppSidebar, TwoFactorAuthenticationLayout, WorkspaceBar, } from './components';
export const WorkspaceNavigationLayout = ({ children }) => {
    _react_refresh_temp_2();
    const { workspaceId = '' } = useParams();
    const { query: { data: workspacesData }, } = useUserWorkspaces();
    const { workspaceBar: { isWorkspaceBarExpanded, setIsWorkspaceBarExpanded }, } = useAppUi();
    const headerPortalElement = document.getElementById(HEADER_PORTAL_ID);
    const { anchorRef, isTooltipActive, tooltipProps, triggerProps } = useTooltip({ placement: 'right' });
    if (workspacesData) {
        const workspace = workspacesData.find(({ id }) => id === workspaceId);
        const shouldShowOnboardingWidget = workspace !== undefined &&
            workspace.memberStatus !== MemberStatus.PENDING;
        return (_jsxs(Box, { isFullHeight: true, isFullWidth: true, children: [headerPortalElement &&
                    createPortal(
                    // eslint-disable-next-line no-restricted-syntax -- pre-existing, predates this rule
                    _jsxs("div", { ...triggerProps, tabIndex: -1, children: [isTooltipActive && (_jsx(Tooltip, { contents: [
                                    translate('{{action}} workspace switcher', {
                                        action: isWorkspaceBarExpanded
                                            ? 'Hide'
                                            : 'Show',
                                    }),
                                ], tooltipProps: tooltipProps })), _jsx(IconButton, { "aria-label": translate('toggle side navigation'), "aria-pressed": isWorkspaceBarExpanded, "data-testid": "help", Icon: LayoutLeftIcon, kind: "ghost", onClick: () => setIsWorkspaceBarExpanded((isExpanded) => !isExpanded), ref: anchorRef, size: "small" })] }), headerPortalElement), _jsx(WorkspaceBar, { isExpanded: isWorkspaceBarExpanded, workspaces: workspacesData }), _jsxs(Box, { gap: "s", isFullWidth: true, kind: "level1", padding: "s", children: [workspace !== undefined && (_jsx(AppSidebar, { shouldShowOnboardingWidget: shouldShowOnboardingWidget, workspace: workspace })), _jsx(TwoFactorAuthenticationLayout, { workspaceId: workspaceId, children: children })] })] }));
    }
    return (_jsx(LoadingBox, { alt: translate('Loading workspaces data'), "data-testid": "loading-workspaces", isFullHeight: true }));
};
_react_refresh_temp_1 = WorkspaceNavigationLayout;
$RefreshReg$(_react_refresh_temp_1, "WorkspaceNavigationLayout");
_react_refresh_temp_2(WorkspaceNavigationLayout, "HCNmR4SPQK0GIwcIsIGbYY3aXUY=", false, () => [useParams, useUserWorkspaces, useAppUi, useTooltip]);
